import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";
import AOS from 'aos';
import 'aos/dist/aos.css';

console.log( 'Hello World! (from create-block-in-numbers block)' );

AOS.init({ duration: 1200 });
document.addEventListener('DOMContentLoaded', () => {
	const swiperContainers = document.querySelectorAll('.in-number-mobile-slider');
	swiperContainers.forEach(container => {
		new Swiper(container, {
			modules: [Navigation, Pagination], // Додаємо модулі Navigation та Pagination
			loop: true,
			spaceBetween: 20,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 1.5,
				}
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	});
});

